<yat-icon [name]="showInput ? 'view-disabled' : 'view-enabled'" class="cursor-pointer" (click)="toggleVisibility()"></yat-icon>
